<template>
  <transition name="ship-fade">
    <div v-if="visible" class="ship-overlay" :class="{ 'no-click': forbidClick }">
      <div class="ship-box">
        <svg class="ship-wheel" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
          <!-- 外圆环 -->
          <circle cx="50" cy="50" r="46" fill="none" stroke="#c8a96e" stroke-width="5"/>
          <!-- 内圆 -->
          <circle cx="50" cy="50" r="10" fill="#c8a96e"/>
          <circle cx="50" cy="50" r="6" fill="#1a1a2e"/>

          <!-- 8 根辐条 + 手柄 -->
          <g v-for="i in 8" :key="i" :transform="`rotate(${i * 45}, 50, 50)`">
            <!-- 辐条 -->
            <line x1="50" y1="18" x2="50" y2="40" stroke="#c8a96e" stroke-width="3.5" stroke-linecap="round"/>
            <!-- 手柄球 -->
            <circle cx="50" cy="10" r="5" fill="#c8a96e"/>
            <circle cx="50" cy="10" r="2.5" fill="#1a1a2e"/>
          </g>
        </svg>
        <p class="ship-text">{{ message }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ShipLoading',
  data() {
    return {
      visible: false,
      message: '加载中...',
      forbidClick: true,
    }
  },
}
</script>

<style scoped>
.ship-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(10, 10, 20, 0.55);
  backdrop-filter: blur(3px);
}
.ship-overlay.no-click { pointer-events: all; }

.ship-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 28px 36px;
  background: linear-gradient(145deg, #1a1a2e, #16213e);
  border: 1px solid rgba(200, 169, 110, 0.35);
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.5), inset 0 1px 0 rgba(200,169,110,0.15);
}

.ship-wheel {
  width: 72px;
  height: 72px;
  animation: spin 1.8s linear infinite;
  filter: drop-shadow(0 0 8px rgba(200, 169, 110, 0.6));
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}

.ship-text {
  margin: 0;
  color: #c8a96e;
  font-size: 13px;
  letter-spacing: 0.08em;
  font-family: serif;
  opacity: 0.9;
}

/* 过渡动画 */
.ship-fade-enter-active, .ship-fade-leave-active {
  transition: opacity 0.2s ease;
}
.ship-fade-enter, .ship-fade-leave-to {
  opacity: 0;
}
</style>